const companyTypesForUserRole = {
  owner: ['assay', 'grading', 'internal', 'external'],
  support: ['assay', 'grading'],
};

export { companyTypesForUserRole };
